/*
  Created By: Sai Prasad
  Created Date: 01/09/2022
  Jira Ticket: JUN-3152
  Description: Store API response to redux.
*/

import { TYPES } from "../../common/constants";
import { createReducer } from "@reduxjs/toolkit";

const saveSuiteResponse = (state, { payload }) => {
    return {...state, suitesImport: payload}
  };
  const saveItemsResponse = (state, { payload }) => {
    return {...state, itemsImport: payload}
  };
  
const clearResponseDone= (state) => {
    return {...state, suitesImport: [], itemsImport: []}
  }

const initialState = {
    suitesImport: [],
    itemsImport: []
};

export default createReducer(initialState, {
  [TYPES.SAVE_SUITE_RESPONSE_DONE]: saveSuiteResponse,
  [TYPES.SAVE_ITEMS_RESPONSE_DONE]: saveItemsResponse,
  [TYPES.CLEAR_RESPONSE_DONE]: clearResponseDone
});
